﻿$(document).ready(function() {
    if ($("div#divUsernameandPasswordUpdate").length) {
       
       
        };
    });